import NavigationComponent from './Navigation.vue'
export default NavigationComponent
